import { render, staticRenderFns } from "./inscricaoCadeiraAtraso.vue?vue&type=template&id=cf2b8cbc&"
import script from "./inscricaoCadeiraAtraso.vue?vue&type=script&lang=js&"
export * from "./inscricaoCadeiraAtraso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports